import React from "react";
import moment from "moment";

// Chart JS
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Filler,
  Legend
);

const StatCardTotal = ({ t, employees, isLoading }) => {
  /* ----- Monthly Counter ----- */
  const total = employees.map((employee) => employee.userId);
  const totalCount = total.length;
  // console.log(totalCount);

  /* ----- Monthly Counter Chart ----- */
  const createdDate = employees
    .sort((a, b) => (a.createdAt > b.createdAt ? 1 : -1)) // Sort by DESC & First month to first
    .reduce((acc, employee) => {
      return {
        ...acc,
        [moment(employee.createdAt).format("YYYY.MM")]:
          (acc[moment(employee.createdAt).format("YYYY.MM")] || 0) + 1,
      };
    }, []);

  //console.log(createdDate)

  /* ----- Chart JS ----- */
  const data = {
    labels: [],
    datasets: [
      {
        fill: false, // Kitöltés
        label: "",
        data: createdDate,
        borderColor: "#fff",
        backgroundColor: "rgba(53, 162, 235, 0.5)",
        //pointStyle: "star",
        //pointBorderColor: "#fff",
        pointBorderWidth: 0,
        tension: 0.5,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    pointBackgroundColor: "#fff",
    radius: 0,
    interaction: {
      intersect: false,
    },
    plugins: {
      legend: {
        display: false,
        position: "top",
      },
    },
    scales: {
      x: {
        display: false,
        grid: { display: false },
        gridLines: {
          color: "rgba(235, 255, 76, 0.5)",
        },
        ticks: {
          display: false,
        },
      },
      y: {
        display: false,
        beginAtZero: true,
        ticks: {
          display: false,
          stepSize: 2, // Párosával mutassa
          //callback: (value) => value + "K",
        },
        grid: {
          //  borderDash: [10],// Szagatott vonal az Y
          display: false,
        },
      },
    },
  };

  return (
    <div className="w-full md:w-1/3 h-44 flex flex-col justify-center items-center bg-gradient-to-r from-[#ee9ae5] to-[#5961f9] text-white tracking-wider rounded-md shadow-lg shadow-blue-400/20 p-4 gap-2">
      <h2 className="text-4xl lg:text-5xl xl:text-6xl text-center font-normal drop-shadow-lg">
        {totalCount}
      </h2>
      <h3 className="text-xl text-center font-normal drop-shadow-lg">
        {t("Statistic.Total")}
      </h3>
      <div className="w-full pb-0 mb-0">
        <Line height={"50px"} width={"100%"} data={data} options={options} />
      </div>
    </div>
  );
};

export default StatCardTotal;
